import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import HomeGallery from "@/pages/HomeGallery";
import PropertyPage from "@/pages/PropertyPage";

function App() {
  return (
    <div className="App min-h-screen bg-[#04271B] font-body" data-testid="app-root">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<HomeGallery />} />
          <Route path="/property/:slug" element={<PropertyPage />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
